export default "__VITE_ASSET__CsB$7kaZ__"